import { defineComponent, computed, createElementBlock, openBlock, Fragment, createBlock, createCommentVNode, createElementVNode, normalizeClass, renderList, toDisplayString } from "vue";
import PSkeletonLoader from "../p-skeleton-loader.js";
import { createPagingRange } from "../pagination.js";
const _imports_0 = "data:image/svg+xml,%3csvg%20width='8'%20height='12'%20viewBox='0%200%208%2012'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M0.25%205.99968C0.25%205.64968%200.4%205.34968%200.65%205.14968L6.25%200.249681C6.65%20-0.100319%207.2%20-0.0503187%207.55%200.349681C7.85%200.749681%207.85%201.29968%207.45%201.59968L2.55%205.89968C2.5%205.94968%202.5%205.99968%202.55%206.04968L7.45%2010.3497C7.85%2010.6997%207.9%2011.2497%207.55%2011.6497C7.2%2012.0497%206.65%2012.0997%206.25%2011.7497C6.25%2011.7497%206.25%2011.7497%206.2%2011.6997L0.65%206.84968C0.4%206.64968%200.25%206.29968%200.25%205.99968Z'%20fill='%23918da1'%20/%3e%3c/svg%3e";
const _imports_1 = "data:image/svg+xml,%3csvg%20width='8'%20height='14'%20viewBox='0%200%208%2014'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M7.75695%206.98136C7.75695%207.33136%207.60695%207.63136%207.35695%207.83136L1.75695%2012.7814C1.35695%2013.1314%200.756947%2013.0814%200.456947%2012.6814C0.156947%2012.2814%200.156947%2011.7314%200.556947%2011.3814L5.45695%207.08136C5.50695%207.03136%205.50695%206.98136%205.45695%206.88136L0.556947%202.58136C0.156947%202.23136%200.156947%201.63136%200.506947%201.28136C0.856947%200.931361%201.40695%200.881361%201.80695%201.18136L7.40695%206.08136C7.60695%206.33136%207.75695%206.63136%207.75695%206.98136Z'%20fill='%23918da1'%20/%3e%3c/svg%3e";
const _hoisted_1 = {
  key: 1,
  class: "flex text-p-gray-40"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "flex" };
const _hoisted_4 = ["aria-label"];
const DOTS = "...";
const BTN_CLASS = "w-6 h-6 flex justify-center items-center mx-1 font-semibold text-sm leading-none";
const BTN_ACTIVE_CLASS = "text-p-purple-60 bg-p-gray-30 rounded-lg";
const BTN_INACTIVE_CLASS = "cursor-pointer";
const ARROW_ACTIVE_CLASS = "cursor-pointer";
const ARROW_INACTIVE_CLASS = "opacity-50";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{ name: "PPagination" },
  __name: "p-pagination",
  props: {
    /**
     * The current page.
     */
    modelValue: {
      type: Number,
      default: null
    },
    /**
     * The amount of data pagination should iterate through.
     */
    count: {
      type: Number,
      default: 0
    },
    /**
     * The amount of data to be displayed at 1 page. Used to calculate the length of pagination.
     */
    pageSize: {
      type: Number,
      default: 10
    },
    /**
     * The amount of pages to be displayed before and after the current page.
     */
    pageOffset: {
      type: Number,
      default: 2
    },
    /**
     * Whether the pagination is loading.
     */
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const props = __props;
    const pageCount = computed(() => {
      return props.count && Math.ceil(props.count / props.pageSize);
    });
    const pages = computed(() => {
      return createPagingRange(Number(props.modelValue), pageCount.value, props.pageOffset, DOTS);
    });
    const setPage = (page) => {
      if (page >= 1 && page <= pageCount.value) {
        emit("update:modelValue", page);
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        __props.loading ? (openBlock(), createBlock(PSkeletonLoader, {
          key: 0,
          class: "h-6 w-56"
        })) : createCommentVNode("", true),
        !__props.loading && pages.value.length > 1 ? (openBlock(), createElementBlock("div", _hoisted_1, [
          createElementVNode("div", {
            class: normalizeClass([BTN_CLASS, Number(__props.modelValue) <= 1 ? ARROW_INACTIVE_CLASS : ARROW_ACTIVE_CLASS]),
            "aria-label": "go to the previous page",
            onClick: _cache[0] || (_cache[0] = ($event) => setPage(Number(__props.modelValue) - 1))
          }, _cache[2] || (_cache[2] = [
            createElementVNode("img", { src: _imports_0 }, null, -1)
          ]), 2),
          (openBlock(true), createElementBlock(Fragment, null, renderList(pages.value, (page, index) => {
            return openBlock(), createElementBlock("div", {
              key: index,
              onClick: ($event) => setPage(Number(page))
            }, [
              createElementVNode("div", _hoisted_3, [
                page !== DOTS ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: normalizeClass([BTN_CLASS, page === __props.modelValue ? BTN_ACTIVE_CLASS : BTN_INACTIVE_CLASS]),
                  "aria-label": `go to page ${page}`
                }, toDisplayString(page), 11, _hoisted_4)) : (openBlock(), createElementBlock("div", {
                  key: 1,
                  class: normalizeClass(BTN_CLASS)
                }, toDisplayString(DOTS)))
              ])
            ], 8, _hoisted_2);
          }), 128)),
          createElementVNode("div", {
            class: normalizeClass([BTN_CLASS, __props.modelValue === pageCount.value ? ARROW_INACTIVE_CLASS : ARROW_ACTIVE_CLASS]),
            "aria-label": "go to the next page",
            onClick: _cache[1] || (_cache[1] = ($event) => setPage(Number(__props.modelValue) + 1))
          }, _cache[3] || (_cache[3] = [
            createElementVNode("img", { src: _imports_1 }, null, -1)
          ]), 2)
        ])) : createCommentVNode("", true)
      ], 64);
    };
  }
});
export {
  _sfc_main as _
};
